import { render } from "./AvisoListagem.vue?vue&type=template&id=b21a880c&scoped=true"
const script = {}

import "./AvisoListagem.vue?vue&type=style&index=0&id=b21a880c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21a880c"]])

export default __exports__